import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as innovationIdea from '../innovation-idea'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: innovationIdea.RESOURCE.payload.dimension.partialId,
      partialId: innovationIdea.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'The lane of support in the Innovation governance structure that this idea falls under',
    isOptional: true,
    name: 'Lane of Support',
    partialId: PartialId.Standard.create('lane_of_support'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
